import React, { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import Utils from "../../../utils";
import NotificationAlert from "./NotificationAlert";
import { getMessageAlert, getNotificationAlert } from "../../../services/CommonService";
import MessageAlert from "./MessageAlert";
import { CLIENT_LOCAL_STORE, IS_CALL } from "../../../configs/AppConfig";
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import { FaComments, FaBell } from 'react-icons/fa';
import { toast } from "react-toastify";
// import './HeaderModern.css';
import Logo from "../../../assets/Images/Docusafe_logo.webp";


// const NavLinks = [
//     { path: '/client-portal', label: 'Home' },
//     { path: '/manage', label: 'Manage' },
//     { path: '/recipients', label: 'Recipients' },
//     { path: '/templates', label: 'Templates' },
//     { path: '/settings', label: 'Setting' },
//     { path: '/billing', label: 'Blling' },
// ]


function Header() {
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [loginUserName, setLoginUserName] = useState('');
  const [loginUserEmail, setLoginUserEmail] = useState('');
  const [totalNotification, setTotalNotification] = useState(5);
  const [notificationList, setNotificationList] = useState([]);
  const [totalMessage, setTotalMessage] = useState(5);
  const [messageAlertList, setMessageAlertList] = useState([]);
  const [isShowBilling, setIsShowBilling] = useState(true);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);


  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const handleScroll = () => setIsScrolled(window.scrollY > 40);


  const location = useLocation();

  const IDLE_TIMEOUT = 12 * 60 * 60 * 1000;

  let idleTimer = null;

  const resetIdleTimer = () => {
    clearTimeout(idleTimer);
    Utils.updateLastActivity();
    idleTimer = setTimeout(() => {
      toast.info('Session timed out. Please log in again.');
      Utils.logout();
    }, IDLE_TIMEOUT);
  };

  useEffect(() => {
    if (Utils.checkSessionExpiry()) {
      return;
    }

    if (!localStorage.getItem('lastActivity')) {
      Utils.updateLastActivity();
    }

    resetIdleTimer();
    const events = ['mousemove', 'keydown', 'touchstart', 'scroll'];
    events.forEach(event => {
      window.addEventListener(event, resetIdleTimer);
    });

    return () => {
      events.forEach(event => {
        window.removeEventListener(event, resetIdleTimer);
      });
      clearTimeout(idleTimer);
    };
  }, []);


  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);


  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setDisplayName(Utils.displayName());
    let loginData = Utils.loginUserData();
    if (Object.keys(loginData).length > 0) {
      setLoginUserName(loginData.first_name + ' ' + loginData.last_name);
      setLoginUserEmail(loginData.email);
      setCompanyName(loginData.company_name);

      if (loginData.role_id > 2) {
        setIsShowBilling(false);
      }
    }
  }, []);

  useEffect(() => {
    onLoadGetNotificationAlert();

    if (IS_CALL === true) {
      const interval = setInterval(() => {
        onLoadGetNotificationAlert();
      }, 10000);

      return () => clearInterval(interval);
    }
  }, []);

  const onLoadGetNotificationAlert = () => {
    getNotificationAlert({})
      .then(response => {
        setTotalNotification(response.data.data.length);
        setNotificationList(response.data.data);
      })
      .catch(err => {

      });
  };

  useEffect(() => {
    onLoadGetMessageAlert();

    if (IS_CALL === true) {
      const interval = setInterval(() => {
        onLoadGetMessageAlert();
      }, 10000);

      return () => clearInterval(interval);
    }
  }, []);

  const onLoadGetMessageAlert = () => {
    getMessageAlert({ entity_type: 1 })
      .then(response => {
        setTotalMessage(response.data.data.length);
        setMessageAlertList(response.data.data);
      })
      .catch(err => {

      });
  };

  const onLogout = () => {
    Utils.logout();
  };

  return (
    <>
      {loading && (
        <div className="page-loading">
          <img src="/images/loader.gif" alt="loader" />
        </div>
      )}

      <nav
        className={`navbar guest-header navbar-expand-lg fixed-top bg-white shadow-sm p-0 ${isScrolled || isMobileMenuOpen ? "scrolled" : ""
          } ${isMobileMenuOpen ? "mobile-menu-open" : ""}`}
      >
        <div className="container">
          <NavLink className="navbar-brand" to="/">
            <img src={Logo} alt="" className="docusafe_logo" />
          </NavLink>

          <button className="navbar-toggler" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? (
              <IoMdClose size={24} />
            ) : (
              <GiHamburgerMenu
                size={24}
              />
            )}
          </button>

          <div
            className={`collapse navbar-collapse ${isMobileMenuOpen ? "show" : ""
              }`}
          >
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active" : ""}`
                  }
                  to="/client-portal"
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active" : ""}`
                  }
                  to="/manage"
                >
                  Manage
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active" : ""}`
                  }
                  to="/recipients"
                >
                  Recipients
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active" : ""}`
                  }
                  to="/templates"
                >
                  Templates
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className={({ isActive }) =>
                    `nav-link ${isActive ? "active" : ""}`
                  }
                  to="/settings"
                >
                  Settings
                </NavLink>
              </li>
              {isShowBilling && (
                <li className="nav-item">
                  <NavLink
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    to="/billing"
                  >
                    Billing
                  </NavLink>
                </li>
              )}
            </ul>

            <div className="d-flex align-items-lg-center mt-lg-0 justify-content-end gap-4 nav-two align-items-center ps-2 px-2 py-1">
              {/* Message Icon */}
              <div
                className="w-full w-lg-auto cur-pointer"
                data-bs-toggle="offcanvas"
                data-bs-target="#message_box"
                aria-controls="message_box"
                data-toggle="tooltip"
                title=""
                data-bs-original-title="Messages"
              >
                <div className="position-relative">
                  <FaComments size={16} />
                  {totalMessage > 0 && (
                    <span
                      className="position-absolute text-center top-0 start-100 translate-middle badge bg-success rounded-4"
                    >
                      {totalMessage}
                    </span>
                  )}
                </div>
              </div>

              {/* Notification Icon */}
              <div
                className="w-full w-lg-auto cur-pointer"
                data-bs-toggle="offcanvas"
                data-bs-target="#notification_box"
                aria-controls="notification_box"
                data-toggle="tooltip"
                title=""
                data-bs-original-title="Alert Notification"
              >
                <div className="position-relative">
                  <FaBell size={16} />
                  {totalNotification > 0 && (
                    <span
                      className="position-absolute text-center top-0 start-100 translate-middle badge bg-danger rounded-4"
                    >
                      {totalNotification}
                    </span>
                  )}
                </div>
              </div>

              {/* User Dropdown */}
              <div className="dropdown">
                <Link
                  className="dropdown-toggle user_login text-decoration-none text-uppercase rounded-circle"
                  to="#"
                  id="navbarDarkDropdownMenuLink"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {displayName}
                </Link>
                <ul
                  className="dropdown-menu border border-2 border-dark-subtle mt-2 user-dropdown-menu"
                  aria-labelledby="navbarDarkDropdownMenuLink"
                >
                  <li className="Company_name">{companyName}</li>
                  <li className="d-flex user_icon_list">
                    <span className="user_icon">{displayName}</span>
                    <p>
                      <span className="user_name">{loginUserName}</span>
                      <span className="user_email">{loginUserEmail}</span>
                      <span className="user_profile user_profile_list">
                        <NavLink
                          to={"/settings"}
                          className="text-decoration-underline"
                        >
                          Profile
                        </NavLink>
                      </span>
                    </p>
                  </li>
                  <li className="sign_out">
                    <span
                      onClick={onLogout}
                      className="cur-pointer text-dark"
                    >
                      Sign Out
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <MessageAlert
        messageAlertList={messageAlertList}
        setMessageAlertList={setMessageAlertList}
        setTotalMessage={setTotalMessage}
        setLoading={setLoading}
      />

      <NotificationAlert
        notificationList={notificationList}
        setNotificationList={setNotificationList}
        setTotalNotification={setTotalNotification}
        setLoading={setLoading}
      />
    </>
  );
}

export default Header;